import { type Duenio, type DuenioRequest } from '../types/duenio';
import { http } from '../../../../api/http';

export class DuenioService {
  private static readonly ENDPOINTS = {
    LIST: '/Catalog/duenios',
    CREATE: '/Catalog/duenios',
    UPDATE: '/Catalog/duenios',
    DELETE: '/Catalog/duenios',
  };

  public static async getDuenios(): Promise<Duenio[]> {
    try {
      const response = await http.get(this.ENDPOINTS.LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching duenios:', error);
      throw error;
    }
  }

  public static async saveDuenio(duenioRequest: DuenioRequest): Promise<Duenio> {
    try {
      const isUpdate = !!duenioRequest.id;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} duenio:`, {
        url: this.ENDPOINTS.CREATE,
        method: 'POST',
        isUpdate,
        data: duenioRequest
      });

      const response = await http.post(this.ENDPOINTS.CREATE, duenioRequest);

      console.log(`Duenio ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${duenioRequest.id ? 'updating' : 'creating'} duenio:`, error);
      throw error;
    }
  }

  public static async deleteDuenio(id: number): Promise<void> {
    try {
      console.log('Deleting duenio:', { id, url: `${this.ENDPOINTS.DELETE}/${id}` });

      await http.delete(`${this.ENDPOINTS.DELETE}/${id}`);

      console.log('Duenio deleted successfully:', id);
    } catch (error) {
      console.error('Error deleting duenio:', error);
      throw error;
    }
  }
}
